import React from 'react';

import PWAComponent from '~containers/contact-options/pwa';

const PWA = () => {
  return (
    <div className="c-box">
      <div className="c-box__content">
        <div className="c-editable">
          <PWAComponent />
        </div>
      </div>
    </div>
  );
};

export default PWA;
